import { ofType } from 'redux-observable';
import {
  catchError,
  delay,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer, iif } from 'rxjs';
import { navigate } from '@reach/router';
import {
  httpMethods,
  multiFileUpload,
} from '../../../../../services/http-service';
import { UPSERT_NOTIFICA } from '../../data.const';
import {
  retrieveNotificaListAction,
  setCurrentNotificaAction,
  setLoaders,
  setPopupInfo,
} from '../../data.action';
import { rootConfig } from '../../../../../config/root-config';

const upsertNotificaEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(UPSERT_NOTIFICA),
    map(({ payload }: any) => {
      const { createdAt, updatedAt, listBody, ...rest } = payload;
      if (rest.id === 'crea') {
        delete rest.id;
      }
      return { body: rest, listBody };
    }),
    tap(p => console.log(`[epic ${UPSERT_NOTIFICA}]`, p)),
    withLatestFrom(state$),
    switchMap(([{ body, listBody }, state]) => {
      return concat(
        of(setLoaders({ notificaLoader: true, page: true })),
        defer(() =>
          from(
            multiFileUpload({
              path: `notifica`,
              method: httpMethods.POST,
              body,
              fileFields: ['relata', 'allegati'],
            })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error(p.message);
              }
              return p?.data?.result;
            }),
            switchMap(data =>
              concat(
                of(setCurrentNotificaAction(data)),
                iif(
                  () => listBody,
                  of(retrieveNotificaListAction(listBody)),
                  EMPTY
                ),
                of(null).pipe(
                  tap(() => {
                    if (body?.id) {
                      return; // do not navigate in case of edit
                    }
                    navigate(
                      `${rootConfig.app_path}/redattore/notifiche-edit/${
                        data?.id || 'crea'
                      }`
                    ).then(() => null);
                  }),
                  delay(500),
                  switchMap(() =>
                    of(
                      setPopupInfo({
                        opened: true,
                        message: 'Operazione completata con successo',
                        timer: 3000,
                      })
                    )
                  )
                )
              )
            ),
            catchError(err => {
              console.error(`[epic ${UPSERT_NOTIFICA}] error`, err);
              return of(
                setPopupInfo({
                  opened: true,
                  message: 'Si è verificato un errore',
                  type: 'BAD',
                  timer: 3000,
                })
              );
            })
          )
        ),
        of(setLoaders({ notificaLoader: false, page: false }))
      );
    })
  );

export default upsertNotificaEpic;
